import React from 'react';
import { DIMENSION_CATALOG } from './constants';
import { Dimension } from './types';

interface DimensionsSectionProps {
  selectedDimensions: Dimension[];
  onChange: (dimensions: Dimension[]) => void;
}

const DimensionsSection: React.FC<DimensionsSectionProps> = ({ selectedDimensions, onChange }) => {
  const handleToggle = (id: Dimension) => {
    if (selectedDimensions.includes(id)) {
      onChange(selectedDimensions.filter((d) => d !== id));
    } else {
      onChange([...selectedDimensions, id]);
    }
  };

  return (
    <div className="p-4 border border-gray-200 rounded-lg hover:border-blue-300 transition-colors">
      <h3 className="text-lg font-medium text-gray-800 mb-1">Dimensions (group by)</h3>
      <p className="text-sm text-gray-500 mb-4">
        Select at least one dimension. Results will be grouped by every selected dimension.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {DIMENSION_CATALOG.map((dim) => {
          const checked = selectedDimensions.includes(dim.id as Dimension);
          return (
            <label
              key={dim.id}
              className="flex items-start gap-3 cursor-pointer group"
            >
              <input
                type="checkbox"
                checked={checked}
                onChange={() => handleToggle(dim.id as Dimension)}
                className="mt-0.5 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
              />
              <div>
                <span className="text-sm font-medium text-gray-800 group-hover:text-blue-700">
                  {dim.label}
                </span>
                {'helperText' in dim && dim.helperText && (
                  <p className="text-xs text-gray-500 mt-0.5">{dim.helperText}</p>
                )}
              </div>
            </label>
          );
        })}
      </div>
      {selectedDimensions.length === 0 && (
        <p className="text-xs text-red-500 mt-3">At least one dimension is required.</p>
      )}
    </div>
  );
};

export default DimensionsSection;
